import { displayHotspots } from "../../../utils/threeD/displayHotspots";
import { entityConfig, defaultValue } from "../common/config";
import * as pc from 'playcanvas';

// Constants for SKU IDs
const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 440 : false;

export const setupGallery = (app, assets, sku_id, galleryEnabled = false, modelConfig) => {
    try {
        const galleryEntity = assets?.gallery?.resource?.instantiateRenderEntity();
        if (galleryEntity) {
            galleryEntity.setLocalScale(
                defaultValue.gallery.localScale.x,
                defaultValue.gallery.localScale.y,
                defaultValue.gallery.localScale.z
            );
            galleryEntity.setLocalPosition(
                defaultValue.gallery.localPosition.x,
                defaultValue.gallery.localPosition.y,
                defaultValue.gallery.localPosition.z
            );
            galleryEntity.setEulerAngles(
                defaultValue.gallery.eulerAngles.x,
                defaultValue.gallery.eulerAngles.y,
                defaultValue.gallery.eulerAngles.z
            );
            app.root.addChild(galleryEntity);
            return galleryEntity;
        }
    } catch (error) {
        console.warn('Failed to setup gallery:', error);
    }
    return null;
};

export const setupLight = (app, adminView=false) => { 
    // Directional Light
    const directionalLight = new pc.Entity();
    directionalLight.addComponent('light', defaultValue.light.directional.directionalConfig);
    directionalLight.setLocalPosition(
        defaultValue.light.directional.localPosition.x, 
        defaultValue.light.directional.localPosition.y, 
        defaultValue.light.directional.localPosition.z
    );
    directionalLight.setEulerAngles(
        defaultValue.light.directional.eulerAngles.x, 
        defaultValue.light.directional.eulerAngles.y, 
        defaultValue.light.directional.eulerAngles.z
    );
    app.root.addChild(directionalLight);

    // Point Light
    const pointLight = new pc.Entity();
    pointLight.addComponent('light', defaultValue.light.point.pointConfig);
    pointLight.setLocalPosition(
        defaultValue.light.point.localPosition.x, 
        defaultValue.light.point.localPosition.y, 
        defaultValue.light.point.localPosition.z
    );
    // app.root.addChild(pointLight);

    // Set initial ambient light
    const ambientLight = new pc.Color(1, 1, 1);
    // app.scene.ambientLight = ambientLight;

    return { directionalLight, pointLight, app };
};

export const setupCamera = (app, sku_id, isMobilePortrait, original = false, modelConfig) => {
    const camera = new pc.Entity();
    camera.addComponent('camera', defaultValue.camera.cameraConfig);

    if (isMobile && typeof window !== 'undefined') {
        const updateFOV = () => {
            camera.camera.fov = window.innerHeight > window.innerWidth ? 60 : 45;
        };

        window.addEventListener('orientationchange', () => {
            setTimeout(updateFOV, 100);
        });
        window.addEventListener('resize', updateFOV);
    }

    camera.setLocalPosition(
        defaultValue.camera.localPosition.x,
        defaultValue.camera.localPosition.y + Number(modelConfig.torus_config.torus_ring_radius),
        defaultValue.camera.localPosition.z + Number(modelConfig.torus_config.torus_inner_radius)
    );
    app.root.addChild(camera);
    camera.lookAt(
        modelConfig.torus_config.camera_center[0], 
        modelConfig.torus_config.camera_center[1], 
        modelConfig.torus_config.camera_center[2]
    );
    return camera;
};

export const setupCar = (app, assets, sku_id, carRef, modelConfig, original = false) => {
    try {
        // const car = assets?.car?.resource?.instantiate({
        //     fragment: assets.car.fragment,
        //     vertex: assets.car.vertex,
        // });
        const car = new pc.Entity();
        car.addComponent('gsplat', {
            asset: assets.car,
            castShadows: true
        });
        // set alpha clip value, used by shadows and picking
        car.gsplat.material.setParameter('alphaClip', 0.4);

        car.setLocalScale(
            defaultValue.car.localScale.x * modelConfig.scale_factor,
            defaultValue.car.localScale.y * modelConfig.scale_factor,
            defaultValue.car.localScale.z * modelConfig.scale_factor
        );

        car.setLocalPosition(
            defaultValue.car.localPosition.x + modelConfig.position.x,
            defaultValue.car.localPosition.y + modelConfig.position.y,
            defaultValue.car.localPosition.z + modelConfig.position.z
        );

        car.setEulerAngles(
            defaultValue.car.eulerAngles.x + modelConfig.rotation.x,
            defaultValue.car.eulerAngles.y + modelConfig.rotation.y + (modelConfig.front_back_correct ? 180 : 0), 
            // 180 degrees for right aligned car where front back correct is true (as we need left aligned car on x-axis at landing)
            defaultValue.car.eulerAngles.z + modelConfig.rotation.z
        );

        carRef.current = car;
        app.root.addChild(car);

    } catch(error){
        console.warn('Failed to setup car:', error);
    }
};

export const setupShadowCaster = (app, assets, sku_id, modelConfig) => {
    try{

        const shadow_casterEntity = assets?.shadow_caster?.resource?.instantiateRenderEntity();
        shadow_casterEntity.render.castShadows = true;
        shadow_casterEntity.render.receiveShadows = true;
        shadow_casterEntity.setLocalScale(
            defaultValue.shadow_caster.localScale.x * modelConfig.scale_factor,
            defaultValue.shadow_caster.localScale.y * modelConfig.scale_factor,
            defaultValue.shadow_caster.localScale.z * modelConfig.scale_factor
        );
        shadow_casterEntity.setEulerAngles(
            defaultValue.shadow_caster.eulerAngles.x + modelConfig.rotation.x,
            defaultValue.shadow_caster.eulerAngles.y + modelConfig.rotation.y,
            defaultValue.shadow_caster.eulerAngles.z + modelConfig.rotation.z
        );
        shadow_casterEntity.setLocalPosition(
            defaultValue.shadow_caster.localPosition.x + modelConfig.position.x,
            defaultValue.shadow_caster.localPosition.y + modelConfig.position.y,
            defaultValue.shadow_caster.localPosition.z + modelConfig.position.z
        );
        // app.root.addChild(shadow_casterEntity);

        // const transparentMaterial = new pc.StandardMaterial();
        // transparentMaterial.opacity = 0;
        // transparentMaterial.blendType = pc.BLEND_NORMAL;
        // transparentMaterial.depthWrite = false;
        // transparentMaterial.redWrite = false;
        // transparentMaterial.greenWrite = false;
        // transparentMaterial.blueWrite = false;
        // transparentMaterial.alphaWrite = false;
        // transparentMaterial.update();
        // shadow_casterEntity.render.meshInstances.forEach((meshInstance) => {
        //     meshInstance.material = transparentMaterial;
        // });
        return shadow_casterEntity;
    } catch(error){
        console.warn('Failed to setup shadow caster:', error);    }
};

export const setupHotspots = (appRef, modelConfig) => {
    if (modelConfig?.hotspots) {
        Object.entries(modelConfig.hotspots).forEach(([, points]) => {
            points.forEach((point) => displayHotspots(point, modelConfig, appRef))
        });
    }
};